<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          :class="searchButtonClass"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>

    <b-card v-if="!showSearchButton">
      <b-row class="position-relative">
        <b-col md="4">
          <validation-observer ref="searchRules">
            <b-form @submit.prevent="handleSearch">
              <b-row>
                <Alert
                  :show="showFormErrorAlert"
                  :message="$t('Customer\'s account name or account number or customer id is required')"
                />

                <b-col md="12">
                  <InputField
                    id="customer-id"
                    v-model="searchParams.customerID"
                    :label="$t('Customer ID')"
                    :placeholder="$t('Enter customer id')"
                    type="text"
                    for="customer-id"
                  />
                </b-col>

                <b-col md="12">
                  <InputField
                    id="customer-name"
                    v-model="searchParams.name"
                    :label="$t('Customer\'s Name')"
                    :placeholder="$t('Enter customer\'s name')"
                    type="text"
                    error-name=""
                    rules=""
                  />
                </b-col>
                <b-col md="12">
                  <InputField
                    id="email"
                    v-model="searchParams.email"
                    :label="$t('Email')"
                    :placeholder="$t('Enter email')"
                    type="text"
                    error-name=""
                    rules=""
                  />
                </b-col>

                <b-col md="12">
                  <Button
                    :label="$t('Search')"
                    size="md"
                    class="mt-2"
                    block
                    @click="handleSearch"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-card>

    <form-wizard
      v-if="showSearchButton"
      ref="loanAccount"
      :title="null"
      :subtitle="null"
      layout="vertical"
      :back-button-text="$t('Previous')"
      :next-button-text="$t('Next')"
      class="wizard-vertical mb-3"
    >

      <!-- Loan Service Account Details tab -->

      <tab-content
        :title="$t('Loan Service Details')"
        :before-change="validateLoanService"
      >
        <validation-observer ref="loanService">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2 mt-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Service Account Details') }}
                </h5>
              </b-col>
              <b-col md="6">
                <InputField
                  id="customer-name"
                  v-model="customer.customerName"
                  :label="$t('Customer Name')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--  Customer's Savings/Current Account -->
              <b-col md="6">
                <SelectField
                  id="saving-account"
                  v-model="loanAccountFormData.linkedNumber"
                  :label="$t('Customer\'s Savings/Current Account')"
                  :options="customerAccountOptions"
                  :placeholder="$t('Select')"
                  :reduce="option => option.value"
                  item="label"
                  rules="required"
                  :error-name="$t('Customer\'s Savings/Current Account')"
                  :set-selected="setCustomerDetails"
                  :readonly="isReadonly"
                />
              </b-col>
              <!--  Customer's Savings/Current Account -->

              <!-- Account Name -->
              <b-col md="6">
                <InputField
                  id="account-name"
                  v-model="customer.accountName"
                  :label="$t('Account Name')"
                  type="text"
                  readonly
                />
              </b-col>
              <!-- Account Name -->

              <!--Product Name -->
              <b-col md="6">
                <InputField
                  id="product-name"
                  v-model="customer.productName"
                  :label="$t('Product Name')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--Product Name -->

              <!--Branch Name -->
              <b-col md="6">
                <InputField
                  id="branch-name"
                  v-model="customer.branchName"
                  :label="$t('Branch Name')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--Branch Name -->

              <!--Loan Officer -->
              <b-col md="6">
                <!-- <InputField
                  id="loan-officer"
                  v-model="customer.accountOfficerName"
                  :label="$t('Loan Officer"
                  type="text"
                  readonly
                /> -->
                <SelectField
                  id="loan-officer"
                  v-model="loanAccountFormData.accountOfficerCode"
                  :label="$t('Loan Officer')"
                  required="true"
                  :error-name="$t('Loan Officer')"
                  :options="accountOfficerOptions"
                  item="label"
                  :reduce="option => option.value"
                  :placeholder="$t('Select loan officer')"
                  rules="required"
                  :readonly="actionType === 'view'"
                  :set-selected="setAccountOfficerName"
                />
              </b-col>
              <!--Loan Officer -->

              <!--Account Status -->
              <b-col md="6">
                <InputField
                  id="account-status"
                  v-model="customer.accountStatus"
                  :label="$t('Account Status')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--Account Status -->

              <!--Any Loan Outstanding -->
              <b-col md="6">
                <InputField
                  id="loan-outstanding"
                  v-model="customer.hasOutstandingLoan"
                  :label="$t('Any Loan Outstanding?')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--Any Loan Outstanding -->

              <!--  Reference Number -->
              <b-col md="6">
                <InputField
                  id="reference-number"
                  v-model="loanAccountFormData.referenceNumber"
                  :label="$t('Reference Number')"
                  :placeholder="$t('Enter reference number')"
                  type="text"
                  :readonly="actionType === 'view'"
                  show-icon
                  :on-click="onViewInfo"
                />
              </b-col>
              <!--  Reference Number -->
              <!--  IPPIS/Oracle ID -->
              <b-col md="6">
                <InputField
                  id="ippis-oracle"
                  v-model="loanAccountFormData.employeeID"
                  :label="$t('IPPIS/Oracle ID')"
                  :placeholder="$t('Enter IPPIS/Oracle ID')"
                  type="text"
                  :readonly="isReadonly"
                />
              </b-col>
              <!--  IPPIS/Oracle ID -->

              <b-col
                v-if="customer.hasOutstandingLoan === 'Yes'"
                md="6"
              >
                <InputField
                  id="total-outstanding-loan"
                  v-model="customer.outstandingLoan"
                  :label="$t('Total Outstanding Loan')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--Any Loan Outstanding -->

              <b-col
                cols="12"
                class="mb-2 mt-2"
              >
                <h5 class="mb-2">
                  Signatory Mandate
                </h5>

                <Button
                  :label="$t('View Signatory Mandate')"
                  size="sm"
                  class="mb-2"
                  @click="onViewSignatoryMandate"
                />
              </b-col>
              <b-col
                v-if="actionType === 'add'"
                cols="12"
                class="mb-2 mt-2"
              >
                <h5 class="mb-2">
                  Remita Lookup
                </h5>

                <Button
                  :label="$t('Remita Lookup Search')"
                  size="sm"
                  class="mb-2"
                  @click="onViewRemitaLookup"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Loan Account Information -->
      <tab-content
        :title="$t('Loan Account Info')"
        :before-change="validateLoanAccountInfo"
      >
        <validation-observer ref="loanAccountRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Account Information') }}
                </h5>
              </b-col>
              <b-col md="6">
                <InputField
                  id="customer-name"
                  v-model="customer.customerName"
                  :label="$t('Customer Name')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col
                v-if="actionType==='add'"
                md="6"
              >
                <SelectField
                  id="loan-product"
                  v-model="loanAccountFormData.productCode"
                  :label="$t('Loan Product')"
                  :reduce="option => option.value"
                  :options="loanProductList"
                  :placeholder="$t('Select')"
                  :error-name="$t('Loan Product')"
                  rules="required"
                  item="label"
                  :set-selected="setLoanFee"
                  :readonly="isEditable"
                />
              </b-col>

              <b-col
                v-else
                md="6"
              >
                <InputField
                  id="loan-product"
                  v-model="loanAccountDetails.productName"
                  :label="$t('Loan Product')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="lending-model"
                  v-model="loanAccountFormData.lendingModel"
                  :label="$t('Lending Model')"
                  :reduce="option => option.value"
                  :options="lendingModelOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Lending Model')"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="economic-sector"
                  v-model="loanAccountFormData.economicSector"
                  :label="$t('Economic Sector')"
                  :reduce="option => option.value"
                  :options="economicSectorOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Economic Sector')"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <!--  Currency Code -->
              <b-col md="6">
                <InputField
                  id="currency-code"
                  v-model="loanAccountFormData.currencyCode"
                  :label="$t('Currency')"
                  :placeholder="$t('Enter currency code')"
                  type="text"
                  readonly
                />
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Period Details') }}
                </h5>
              </b-col>

              <b-col md="6">
                <InputField
                  id="failed-repayment"
                  v-model.number="loanAccountFormData.penaltyGracePeriod"
                  :label="$t('Failed Repayment Grace Period')"
                  type="number"
                  :error-name="$t('Failed Repayment Grace Period')"
                  rules="integer|positive"
                  :readonly="isEditable"
                />

              </b-col>
              <b-col md="6">
                <InputNumberField
                  id="loan-principal"
                  v-model="loanAccountFormData.loanAmount"
                  :label="$t('Loan Principal Amount')"
                  :error-name="$t('Loan Principal Amount')"
                  rules="required"
                  :on-input="setSecurityDeposit"
                  :readonly="isEditable"
                />
              </b-col>
              <b-col md="6">
                <DatePickerField
                  id="start-date"
                  v-model="loanAccountFormData.startDate"
                  rules="required"
                  :label="$t('Loan Start Date')"
                  :error-name="$t('Loan Start Date')"
                  :on-change="setEndDate"
                  :config="datePickerConfig"
                  :placeholder="$t('Select Loan Start Date')"
                  :disabled="isEditable"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="interest-accrual"
                  v-model="loanAccountFormData.interestCommencementDate"
                  :label="$t('Profit Accrual Start Date')"
                  type="text"
                  :error-name="$t('Profit Accrual Start Date')"
                  rules="required"
                  readonly
                />
              </b-col>
              <b-col md="6">
                <DatePickerField
                  id="first-repayment-date"
                  v-model="loanAccountFormData.firstRepaymentDate"
                  :label="$t('Loan First Repayment Date')"
                  :config="datePickerConfig"
                  :placeholder="$t('Select Loan First Repayment Date')"
                  :disabled="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Repayment Information -->
      <tab-content
        :title="$t('Repayment Info')"
        :before-change="validateRepaymentInfo"
      >
        <validation-observer ref="repaymentInfo">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Principal Repayment Information') }}
                </h5>
              </b-col>

              <b-col md="6">
                <SelectField
                  id="principal-repayment"
                  v-model="loanAccountFormData.principalRepaymentType"
                  :label="$t('Principal Repayment')"
                  :reduce="option => option.value"
                  :options="repaymentTypeOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Principal Repayment')"
                  rules="required"
                  item="label"
                  :readonly="isEditable"
                  @change="checkPrincipalRepayment"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <InputField
                  id="principal-to-be-repaid"
                  v-model.number="loanAccountFormData.principalToBeRepaidEvery"
                  :label="$t('Principal To Be Repaid Every')"
                  type="number"
                  :error-name="$t('Principal To Be Repaid Every')"
                  rules="required|integer|positive"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                  :on-input="computeTenure1"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="principal-repayment-frequency"
                  v-model="loanAccountFormData.principalFrequency"
                  :label="$t('Principal Repayment Frequency')"
                  :reduce="option => option.value"
                  :options="frequencyOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Principal Repayment Frequency')"
                  :set-selected="computeTenure2"
                  rules="required"
                  item="label"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="principal-installment"
                  v-model.number="loanAccountFormData.principalInstallment"
                  :label="$t('Over')"
                  type="number"
                  :error-name="$t('Principal Installment')"
                  rules="required|integer|positive"
                  :readonly="isEditable"
                  text="Installments"
                  :on-input="computeTenure3"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="tenure"
                  v-model.number="loanAccountFormData.tenure"
                  :label="$t('Tenure')"
                  type="number"
                  readonly
                />
              </b-col>

            </b-row>

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Profit Repayment Information') }}
                </h5>
              </b-col>

              <b-col
                v-if="actionType === 'add'"
                md="6"
              >
                <SelectField
                  id="applicable-interest"
                  v-model="loanAccountFormData.applicableInterestCode"
                  :label="$t('Select Applicable Profit')"
                  :reduce="option => option.value"
                  :options="interestApplicationOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Select Applicable Profit')"
                  rules="required"
                  item="label"
                  :set-selected="setApplicableInterest"
                  :readonly="!useProductInterestRate || isEditable"
                />
              </b-col>
              <b-col
                v-else
                md="6"
              >
                <InputField
                  id="applicable-interest"
                  v-model="loanAccountDetails.applicableInterest"
                  :label="$t('Applicable Profit')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="useProductInterestRate"
                  :label="$t('Override Product Profit Rate?')"
                  name="use-product-interest-rate"
                  style="text-align: right"
                  :readonly="isEditable"
                />
                <InputField
                  id="applicable-interest-rate"
                  v-model.number="loanAccountFormData.applicableInterestRate"
                  :label="$t('Applicable Profit Rate')"
                  type="number"
                  style="margin-top: -35px;"
                  rules="custom-maxValue:200|positive"
                  :readonly="!useProductInterestRate || isEditable"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="defaulting-loan-rate"
                  v-model="loanAccountFormData.defaultingInterestRate"
                  :label="$t('Defaulting Loan Interest Rate')"
                  type="number"
                  :error-name="$t('Defaulting Loan Interest Rate')"
                  rules="max-value:100"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-computation-mode"
                  v-model="loanAccountFormData.interestAccrualMode"
                  :label="$t('Profit Computation Mode')"
                  :reduce="option => option.value"
                  :options="interestAccrualOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Profit Computation Mode')"
                  rules="required"
                  item="label"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-repayment-rate"
                  v-model="loanAccountFormData.interestRepaymentType"
                  :label="$t('Profit Repayment')"
                  :reduce="option => option.value"
                  :options="repaymentTypeOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Profit Repayment')"
                  rules="required"
                  item="label"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <InputField
                  id="interest-to-be-repaid"
                  v-model.number="loanAccountFormData.interestToBeRepaidEvery"
                  :label="$t('Profit To Be Repaid Every')"
                  type="number"
                  :error-name="$t('Profit To Be Repaid Every')"
                  rules="required|integer|positive"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="interest-repayment-frequency"
                  v-model="loanAccountFormData.interestFrequency"
                  :label="$t('Profit Repayment Frequency')"
                  :reduce="option => option.value"
                  :options="frequencyOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Profit Repayment Frequency')"
                  rules="required"
                  item="label"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="interest-installment"
                  v-model.number="loanAccountFormData.interestInstallment"
                  :label="$t('Over')"
                  type="number"
                  :error-name="$t('Profit Installment')"
                  rules="required|integer|positive"
                  :readonly="equalMonthlyInstallment ? equalMonthlyInstallment : isEditable"
                  text="Installments"
                />
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Fee Information') }}
                </h5>
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="loanAccountFormData.applyLoanFees"
                  :label="$t('Apply Loan Fee')"
                  name="apply-loan-fee"
                  class="mt-2"
                  :readonly="isEditable"
                />
              </b-col>
              <b-col
                v-if="setApplyLoanFee(loanAccountFormData.applyLoanFees)"
                md="6"
              >
                <SelectField
                  id="loan-fee"
                  v-model="loanAccountFormData.loanFees"
                  :label="$t('Loan Fee')"
                  :reduce="option => option"
                  :options="loanFeeOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Select Loan Fee')"
                  item="label"
                  multiple
                  :readonly="isEditable"
                />
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Moratorium') }}
                </h5>
              </b-col>

              <b-col md="12">
                <SwitchButton
                  v-model="isIgnoreProductDefault"
                  :label="$t('Ignore Product Default')"
                  name="ignore-product-default"
                  class="mt-2"
                  :readonly="isEditable"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="alow-moratorium-loan"
                  v-model="loanAccountFormData.allowMoratorium"
                  :label="$t('Allow Moratorium On Loan Repayment')"
                  :reduce="option => option.value"
                  :options="moratoriumTypeOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Allow Moratorium On Loan Repayment')"
                  :rules="productDefaultRules"
                  item="label"
                  :readonly="!isIgnoreProductDefault"
                  :set-selected="setMoratorium"
                />
              </b-col>
            </b-row>

            <b-row v-if="isAllowMoratorium">
              <b-col
                md="6"
              >
                <SelectField
                  id="moratorium-effect"
                  v-model="loanAccountFormData.moratoriumEffect"
                  :label="$t('Moratorium Effect On Loan Duration')"
                  :reduce="option => option.value"
                  :options="moratoriumEffectOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Moratorium Effect On Loan Duration')"
                  :rules="productDefaultRules"
                  item="label"
                  :readonly="!isIgnoreProductDefault"
                />
              </b-col>

              <b-col
                md="6"
              >
                <InputField
                  id="moratorium-duration"
                  v-model.number="loanAccountFormData.moratoriumDuration"
                  :label="$t('Moratorium Duration')"
                  :placeholder="$t('Enter moratorium duration')"
                  type="number"
                  :error-name="$t('Moratorium Duration')"
                  :rules="moratoriumDurationRules"
                  :readonly="!isIgnoreProductDefault"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="frequency"
                  v-model="loanAccountFormData.moratoriumFrequency"
                  :label="$t('Frequency')"
                  :options="moratoriumFrequencyOptions"
                  :reduce="option => option.value"
                  :placeholder="$t('Select')"
                  :error-name="$t(' Frequency')"
                  :rules="productDefaultRules"
                  item="label"
                  :readonly="!isIgnoreProductDefault"
                />
              </b-col>
            </b-row>

            <b-row v-if="showComputedInterest">
              <b-col
                md="6"
              >
                <TextAreaField
                  id="computed-interest"
                  v-model="computedInterest"
                  :label="$t('Computed Profit')"
                  type="text"
                  rows="2"
                  readonly
                />
              </b-col>
            </b-row>

            <div class="d-flex flex-wrap">
              <Button
                v-if="actionType !== 'view'"
                :label="$t('Compute Profit')"
                :loading="isLoadingComputeInterest"
                :disabled="isDisabledComputeInterest"
                size="sm"
                class="mt-3 mb-2"
                @click="computeInterest"
              />

              <Button
                v-if="actionType !== 'view'"
                :label="$t('View Repayment Schedule')"
                :loading="isLoadingComputeInterest"
                :disabled="isDisabledComputeInterest"
                size="sm"
                class="mt-3 mb-2 ml-lg-2 ml-md-2"
                @click="onViewRepaymentSchedule"
              />
            </div>

          </b-form>
        </validation-observer>
      </tab-content>

      <!--Collateral & Security Deposit Informations -->
      <tab-content
        :title="$t('Collateral & Security')"
        :before-change="validateCollateralAndSecurity"
      >
        <validation-observer ref="collateralSecurity">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Collateral & Security Deposit Information') }}
                </h5>
              </b-col>

              <b-col md="6">
                <InputNumberField
                  id="required-security"
                  v-model="loanAccountFormData.securityDeposit"
                  :label="$t('Required Security Deposit Amount')"
                  :error-name="$t('Security Deposit Amount')"
                  rules="required"
                  :readonly="isEditable"
                  :is-allow-negative-numbers="false"
                  onpaste="return false;"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <SwitchButton
                  v-model="loanAccountFormData.hasCollateralPledge"
                  :label="$t('Collateral Pledge')"
                  name="collateral-pledge"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <b-row v-if="setCollateral(loanAccountFormData.hasCollateralPledge)">
              <b-col md="6">
                <SelectField
                  id="type-of-collateral"
                  v-model="loanAccountFormData.collateralType"
                  :label="$t('Type of Collateral')"
                  :options="securityTypesOptions"
                  :reduce="option => option.value"
                  :placeholder="$t('Select')"
                  :error-name="$t('Type of Collateral')"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputNumberField
                  id="collateral-valuation"
                  v-model="loanAccountFormData.collateralValuation"
                  :label="$t('Collateral Valuation')"
                  :error-name="$t('Collateral Valuation')"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="12">
                <TextAreaField
                  id="detailed-description"
                  v-model="loanAccountFormData.collateralDescription"
                  :label="$t('Detailed Description')"
                  :placeholder="$t('Enter description')"
                  :error-name="$t('Detailed Desciption')"
                  rules="required|max:150"
                  rows="5"
                  :on-input="setDescriptionCount"
                  :readonly="isReadonly"
                />
                <small :class="descriptionCountClass">{{ `${descriptionCount} / 150` }}</small>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                cols="12"
                class="mt-3 mb-0"
              >
                <h5>{{ $t('Allow Disbursements To GL') }} </h5>
              </b-col>
              <b-col
                md="12"
              >
                <SwitchButton
                  v-model="loanAccountFormData.allowDisbursementsToGL"
                  :label="$t('Allow Disbursements to GL')"
                  name="allow-disbursements-to-gl"
                  class="mt-2"
                  :readonly="loanAccountFormData.isAllowDisbursementsToGL ? isEditable : ''"
                />
              </b-col>
              <b-col
                v-if="loanAccountFormData.allowDisbursementsToGL"
                class="align-items-center"
                md="6"
              >
                <SelectField
                  id="clearing-bank-gl"
                  v-model="loanAccountFormData.clearingBankGL"
                  :label="$t('Clearing Bank GL')"
                  :options="clearingBankOptions"
                  :placeholder="$t('Select')"
                  :reduce="option => option.value"
                  item="label"
                  rules="required"
                  :error-name="$t('Clearing Bank GL')"
                  :readonly="isEditable"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col
                cols="12"
                class="mt-3 mb-0"
              >
                <h5> {{ $t('Loan Repayment Tracker') }}</h5>
              </b-col>
              <b-col md="12">
                <SwitchButton
                  v-model="loanAccountFormData.enableRepaymentTracker"
                  :label="$t('Enable Repayment Tracker')"
                  name="enable-repayment-tracker"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col
                v-if="setRepaymentTracker(loanAccountFormData.enableRepaymentTracker)"
                class="align-items-center"
                md="6"
              >
                <InputField
                  id="repayment-trackerInDays"
                  v-model.number="loanAccountFormData.repaymentTrackerInDays"
                  :label="$t('Repayment Tracker in Days')"
                  :placeholder="$t('Enter Repayment Tracker in Days')"
                  type="number"
                  :error-name="$t('Repayment Tracker in Days')"
                  rules="required|integer|positive"
                  :readonly="isReadonly"
                  :is-allow-negative-numbers="false"
                  onpaste="return false;"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!--Guarantor Information -->
      <tab-content
        :title="$t('Guarantor Info')"
      >
        <validation-observer ref="loanFeeRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Guarantor Information') }}
                </h5>
              </b-col>
            </b-row>
            <b-row
              v-for="(item, index) in guarantorList"
              :id="item.id"
              :key="index"
              class="mt-2"
            >
              <b-col md="4">
                <InputField
                  id="customer-name"
                  v-model="item.customerName"
                  :label="`${$t('Guarantor')} ${index + 1}`"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="phone-number"
                  v-model="item.phoneNumber"
                  :label="`${$t('Guarantor')} ${index + 1} ${$t('Phone Number')}`"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col
                md="2"
                class="mt-2"
              >
                <!-- Remove Button -->
                <feather-icon
                  v-if="actionType !== 'view'"
                  v-b-tooltip.hover.bottom="'Remove'"
                  icon="XIcon"
                  class="mr-25 cursor-pointer text-danger"
                  @click="removeGuarantorItem(index)"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <Button
                  v-if="actionType !== 'view'"
                  :label="$t('Add Guarantors')"
                  size="md"
                  :disabled="guarantorLimit"
                  @click="showModal('guarantor-modal')"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>
      <!-- Other Documents tab-->
      <tab-content
        :title="$t('Other Documents')"
        :before-change="validatUploads"
      >
        <validation-observer ref="uploadRules">
          <b-form>
            <div>
              <div class="w-full mt-4 p-10">
                <div class="d-flex mb-0 mt-2 align-items-center justify-content-between">
                  <h4>{{ $t('Other Documents Upload') }}</h4>

                  <b-button
                    v-if="actionType !== 'view'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-4"
                    @click="addNewDocument()"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                    />
                    <span>{{ $t('Add New Document') }}</span>
                  </b-button>
                </div>
                <b-row
                  v-for="(item, index) in documentsFormData"
                  :id="index"
                  :key="index"
                  class="mb-2"
                >
                  <b-col md="6">
                    <SelectField
                      id="document-type"
                      v-model="item.type"
                      :reduce="option => option.value"
                      :label="$t('Document Type')"
                      :placeholder="$t('Select')"
                      :options="translatedDocumentTypeOptions"
                      :error-name="$t('Document Type')"
                      rules="required"
                      item="label"
                      :readonly="isReadonly"
                    />
                  </b-col>
                  <b-col
                    md="7"
                  >
                    <label>{{ $t('Upload Documents') }}</label>

                    <div class="upload-image">
                      <Spinner :show="documentLoadSpinner" />
                      <b-form-group>
                        <b-form-file
                          :placeholder="$t('Choose a file or drop it here...')"
                          :drop-placeholder="$t('Drop file here...')"
                          accept="image/jpeg, image/png, image/jpg, application/pdf, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          plain
                          :disabled="isDisabled"
                          @change="onDocumentsUpload(index, $event)"
                        />
                        <div
                          v-if="!item.url"
                          class="upload-instruction"
                        >
                          <h4>{{ $t('Upload Document File') }}</h4>
                          <p>{{ $t('Drag & drop file or choose from your device to upload') }}</p>
                          <p class="format">
                            {{ $t('Format accepted') }} (jpg, png, jpeg, docx, pdf)
                          </p>
                        </div>
                        <div v-else>
                          <div v-if="item.fileExtension === 'png'|| item.fileExtension === 'jpeg'|| item.fileExtension === 'jpg'">
                            <b-img
                              :src="item.url"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div
                            v-if="item.fileExtension === 'pdf'"
                          >
                            <b-img
                              :src="pdfIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div
                            v-else-if="item.fileExtension === 'vnd'"
                          >
                            <b-img
                              :src="wordIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div
                            v-else
                          >
                            <b-img
                              src=""
                            />
                          </div>
                          <div
                            v-if="item.url && actionType !== 'view'"
                            class="trash"
                          >
                            <feather-icon
                              icon="Trash2Icon"
                              size="20"
                              class="text-primary"
                              @click="deleteDocumentFile(item.id, index)"
                            />
                          </div>
                          <div
                            v-if="item.url"
                            class="view-details"
                          >
                            <feather-icon
                              icon="EyeIcon"
                              size="20"
                              class="text-primary"
                              @click="viewDocumentFile(item.url, item.fileName, item.fileExtension)"
                            />
                          </div>
                          <!-- </div> -->
                        </div>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col
                    md="3"
                    class="mt-0"
                  >
                    <b-row>
                      <!-- Remove Button -->
                      <b-col
                        v-if="item.url"
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-if="actionType !== 'view'"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="removeDocument(item.id, index)"
                        >
                          <feather-icon
                            icon="XIcon"
                            class="mr-25"
                          />
                          <span>{{ $t('Remove') }}</span>
                        </b-button>
                      </b-col>
                      <b-col
                        v-if="item.url"
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="handleDownload(item.url)"
                        >
                          <feather-icon
                            icon="DownloadIcon"
                            class="mr-25"
                          />
                          <span>{{ $t('Download') }}</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </tab-content>

      <template
        slot="finish"
      >
        <div class="wizard-footer-right">
          <Button
            v-if="actionType !== 'view'"
            :label="$t('Submit')"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </template>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>

    <b-modal
      id="search-modal"
      ref="search-modal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Account Details')"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        :per-page="pageSize"
        :current-page="customerSearchPagination.currentPage"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >
        <template #cell(SN)="data">
          {{ repaymentScheduleNumbering(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="customerSearchPagination.currentPage"
        :from="customerSearchFrom"
        :to="customerSearchTo"
        :total-rows="customerSearchPagination.totalEntries"
        :per-page="customerSearchPagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <!-- Guarantor modal -->
    <b-modal
      id="guarantor-modal"
      ref="guarantorModal"
      :ok-title="$t('Search')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="md"
      :title="$t('Search Guarantor')"
      modal-footer
      @ok="handleGuarantorSearch"
      @cancel="resetGuarantorModal"
      @hidden="resetGuarantorModal"
    >
      <validation-observer ref="searchRules">
        <b-form @submit.prevent="handleGuarantorSearch">
          <b-row class="match-height">
            <Alert
              :show="showFormErrorAlert"
              :message="$t('Customer\'s account name or account number or customer id is required')"
            />
            <b-col md="12">
              <InputField
                id="customer-id"
                v-model="guarantorSearchFormData.customerID"
                :label="$t('Customer ID')"
                :placeholder="$t('Enter customer id')"
                type="text"
              />
            </b-col>

            <b-col md="12">
              <InputField
                id="customer-name"
                v-model="guarantorSearchFormData.name"
                :label="$t('Customer\'s Name')"
                :placeholder="$t('Enter customer\'s name')"
                type="text"
                error-name=""
                rules=""
              />
            </b-col>

            <b-col md="12">
              <InputField
                id="email-address"
                v-model="guarantorSearchFormData.email"
                :label="$t('Customer\'s Email')"
                :placeholder="$t('Enter email address')"
                type="email"
              />
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
      id="guarantor-search-modal"
      ref="guarantorSearchModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Account Details')"
    >

      <b-table
        ref="guarantorListTable"
        select-mode="single"
        :items="guarantors"
        :per-page="pageSize"
        :current-page="guarantorPagination.currentPage"
        responsive
        :fields="translatedGuarantorTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectGuarantor"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>

      <TablePagination
        v-model="guarantorPagination.currentPage"
        :from="guarantorFrom"
        :to="guarantorTo"
        :total-rows="guarantorPagination.totalEntries"
        :per-page="guarantorPagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="repayment-schedule-modal"
      ref="repaymentScheduleModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Repayment Schedule')"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <TableEntries
              v-model="repaymentSchedulePagination.perPage"
              :options="perPageOptions"
            />

          </b-col>

          <!-- Export -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown
                id="dropdown-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :text="$t('Export')"
                variant="primary"
              >
                <b-dropdown-item @click="csvExport(csvData)">
                  {{ $t('CSV') }}
                </b-dropdown-item>
                <b-dropdown-item @click="excelExport(csvData)">
                  {{ $t('Excel') }}
                </b-dropdown-item>
                <b-dropdown-item @click="pdfExport()">
                  {{ $t('PDF') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-col>

        </b-row>

      </div>

      <b-table
        ref="repaymentScheduleModalTable"
        select-mode="single"
        :items="repaymentSchedules"
        responsive
        no-local-sorting
        :fields="translatedRepaymentScheduleTableHeaders"
        :per-page="repaymentSchedulePagination.perPage"
        :current-page="repaymentSchedulePagination.currentPage"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getPageNumber(data.index) }}
        </template>
      </b-table>

      <TablePagination
        v-model="repaymentSchedulePagination.currentPage"
        :from="repaymentFrom"
        :to="repaymentTo"
        :total-rows="repaymentSchedulePagination.totalEntries"
        :per-page="repaymentSchedulePagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="signatory-mandate-table"
      ref="signatoryMandateTable"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Signatory Mandate')"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <TableEntries
              v-model="repaymentSchedulePagination.perPage"
              :options="perPageOptions"
            />

          </b-col>

        </b-row>

      </div>

      <b-table
        ref="signatoryMandateTable"
        select-mode="single"
        :items="signatoryMandateList"
        responsive
        :fields="translatedSignatoryMandateTableHeaders"
        :per-page="repaymentSchedulePagination.perPage"
        :current-page="repaymentSchedulePagination.currentPage"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

        <template #cell(passport)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.passport"
                button
                @click="onViewPassport(data.item.passport, data.item.fullName)"
              />
            </template>
          </b-media>
        </template>

        <template #cell(signature)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.signature"
                button
                @click="onViewSignature(data.item.signature, data.item.fullName)"
              />
            </template>
          </b-media>
        </template>
      </b-table>

      <TablePagination
        v-model="repaymentSchedulePagination.currentPage"
        :from="repaymentFrom"
        :to="repaymentTo"
        :total-rows="repaymentSchedulePagination.totalEntries"
        :per-page="repaymentSchedulePagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="avatar-modal"
      ref="avatarModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="avatarModalTitle"
      @hidden="resetAvatarModal"
      @cancel="resetAvatarModal"
    >

      <div class="m-2 text-center">

        <b-row>
          <b-col cols="12">

            <b-avatar
              size="30rem"
              :src="avatarLg"
            />
          </b-col>

        </b-row>

      </div>

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <!-- Remita Lookup Search -->
    <b-modal
      id="remita-lookup-search-table"
      ref="remitaLookupSearchTable"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="lg"
      :title="$t('Remita Lookup Search')"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <!-- <TableEntries
              v-model="repaymentSchedulePagination.perPage"
              :options="perPageOptions"
            /> -->
            <validation-observer ref="remitaLookupRef">
              <b-form @submit.prevent="handleRemitaSearch">
                <b-row class="match-height">

                  <b-col md="4">
                    <InputField
                      id="first-name"
                      v-model="remitaLookUpData.firstName"
                      :label="$t('First Name')"
                      :placeholder="$t('First Name')"
                      type="text"
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="last-name"
                      v-model="remitaLookUpData.lastName"
                      :label="$t('Last Name')"
                      :placeholder="$t('Last Name')"
                      type="text"
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="middle-name"
                      v-model="remitaLookUpData.middleName"
                      :label="$t('Middle Name')"
                      :placeholder="$t('Middle Name')"
                      type="text"
                    />
                  </b-col>
                  <b-col md="4">
                    <SelectField
                      id="bank-code"
                      v-model="remitaLookUpData.bankCode"
                      :label="$t('Salary Bank')"
                      :options="salaryBankOptions"
                      :placeholder="$t('Select')"
                      :reduce="option => option.value"
                      item="label"
                      rules="required"
                      :error-name="$t('Salary Bank')"
                      :readonly="isEditable"
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="account-number"
                      v-model="remitaLookUpData.accountNumber"
                      :label="$t('Salary Account Number')"
                      :placeholder="$t('Salary Account Number')"
                      type="number"
                      rules="required"
                      :error-name="$t('Salary Account Number')"
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="bvn"
                      v-model="remitaLookUpData.bvn"
                      :label="$t('BVN')"
                      :placeholder="$t('BVN')"
                      type="text"
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="authorization-code"
                      v-model="remitaLookUpData.authorisationCode"
                      :label="$t('Authorisation Code')"
                      :placeholder="$t('Authorisation Code')"
                      type="text"
                      :rules="`required|authorisation-min: ${100000}|authorisation-max: ${9999999999}`"
                      :error-name="$t('Authorisation Code')"
                    />
                  </b-col>

                  <b-col md="4">
                    <Button
                      :label="$t('Search')"
                      size="md"
                      class="mt-2"
                      :loading="isRemitaSearchLoading"
                      :disabled="isRemitaSearchDisabled"
                      @click="handleRemitaSearch"
                    />
                  </b-col>
                  <b-col
                    v-if="isProceedingWithRemita"
                    md="4"
                  >
                    <Button
                      :label="$t('Proceed')"
                      size="md"
                      class="mt-2"
                      @click="proceedWithRemita"
                    />
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>

          </b-col>

        </b-row>

      </div>
      <b-col
        cols="12"
        class="mt-1 mb-0"
      >
        <h5 class="section-label mb-0">
          {{ $t('Salary Payment Details') }}
        </h5>
      </b-col>

      <b-table
        ref="salaryPaymentTable"
        select-mode="single"
        :items="salaryPaymentDetails"
        responsive
        :fields="translatedSalaryPaymentTableHeaders"
        :per-page="salaryPaymentDetailsPagination.perPage"
        :current-page="salaryPaymentDetailsPagination.currentPage"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ salaryPaymentPageNumber(data.index) }}
        </template>

        <template #cell(amount)="data">
          {{ toBalance(data.value) }}
        </template>

        <template #cell(paymentDate)="data">
          {{ data.value ? toDateWithYear(checkDateFormat(data.value)) : '' }}
        </template>
      </b-table>
      <TablePagination
        v-model="salaryPaymentDetailsPagination.currentPage"
        :from="salaryPaymentDetailsFrom"
        :to="salaryPaymentDetailsTo"
        :total-rows="salaryPaymentDetailsPagination.totalEntries"
        :per-page="salaryPaymentDetailsPagination.perPage"
      />

      <b-col
        cols="12"
        class="mt-3 mb-0"
      >
        <h5 class="section-label mb-0">
          {{ $t('Loan History Details') }}
        </h5>
      </b-col>
      <b-table
        ref="loanHistoryTable"
        select-mode="single"
        :items="loanHistoryDetails"
        responsive
        :fields="translatedLoanHistoryTableHeaders"
        :per-page="loanHistoryDetailsPagination.perPage"
        :current-page="loanHistoryDetailsPagination.currentPage"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getLoanHistoryPageNumber(data.index) }}
        </template>

        <template #cell(loanAmount)="data">
          {{ toBalance(data.value) }}
        </template>
        <template #cell(outstandingAmount)="data">
          {{ toBalance(data.value) }}
        </template>
        <template #cell(repaymentAmount)="data">
          {{ toBalance(data.value) }}
        </template>

        <template #cell(loanDisbursementDate)="data">
          {{ data.value ? toDateWithYear(checkDateFormat(data.value)) : '' }}
        </template>

        <template #cell(status)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
      </b-table>

      <TablePagination
        v-model="loanHistoryDetailsPagination.currentPage"
        :from="loanHistoryDetailsFrom"
        :to="loanHistoryDetailsTo"
        :total-rows="loanHistoryDetailsPagination.totalEntries"
        :per-page="loanHistoryDetailsPagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="info-modal"
      ref="infoModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Okay')"
      @ok="hideModal('info-modal')"
    >
      <div class="p-2">
        <p>{{ $t('External Loan Reference') }} </p>
      </div>
    </b-modal>
    <b-modal
      id="view-avatar-modal"
      ref="avatarModal"
      no-close-on-backdrop
      :ok-title="$t('Download File')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="viewDocumentModalTitle"
      @hidden="resetDocumentModal"
      @cancel="resetDocumentModal"
      @ok="handleDownload(viewDocumentData)"
    >
      <div class="m-2 text-center">
        <b-row>
          <b-col cols="12">
            <div v-if="fileExtension === 'png'|| fileExtension === 'jpeg'|| fileExtension === 'jpg'">
              <b-img
                :src="viewDocumentData"
                block
                fluid
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'pdf'">
              <b-img
                :src="pdfIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'vnd'">
              <b-img
                :src="wordIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else>
              <b-img
                src=""
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <FullScreenSpinner :show="showSpinner" />
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
import { modalMixins } from '@core/mixins/modal'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { toastAlert } from '@core/mixins/toast'
import { maxValue, positive, required } from '@validations'
import {
  BAvatar, BCard, BCol, BDropdown, BDropdownItem, BForm, BMedia, BRow, BTable, VBTooltip, BFormGroup, BFormFile, BImg, BButton, BBadge,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
// import { v4 as uuidv4 } from 'uuid'
import { exportToCSV, exportToExcel, exportToPDF } from '@/helpers/export'
import { toBalance, toKobo, formatAmount } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import Spinner from '@/views/components/spinner/Spinner.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import addSpaceToString from '../../../../../helpers/addSpaceToString'
import {
  industrialSectorsAndCod, interestAccruals, lendingModel, limits, moratoriumEffect, moratoriumType, penaltyCharges, periodPenalties, repaidFrequencies, repaymentTypes, securityDeposits,
  securityDepositTypes, securityTypes, pdfIcon, wordIcon,
} from '../../../../../helpers/data'
import {
  toDateWithMonth, toDateWithYear, toYearWithDate, checkDateFormat,
} from '../../../../../helpers/formatDate'
import getEndDate from '../../../../../helpers/getEndDate'
import getStatusColor from '../../../../../helpers/getStatusColor'
import { accountPermissions } from '../../../../../helpers/permissions'
import Alert from '../../../../components/alert/Alert.vue'
import Button from '../../../../components/button/Button.vue'
import SwitchButton from '../../../../components/switch/Switch.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import InputField from '../../../../forms/InputField.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import TextAreaField from '../../../../forms/TextAreaField.vue'

export default {
  components: {
    FormWizard,
    TabContent,
    BCard,
    BRow,
    BForm,
    BCol,
    Button,
    BTable,
    Spinner,
    FullScreenSpinner,
    SwitchButton,
    InputField,
    SelectField,
    TextAreaField,
    ValidationObserver,
    BMedia,
    BAvatar,
    Alert,
    TablePagination,
    DatePickerField,
    InputNumberField,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormFile,
    BImg,
    BBadge,
    BButton,
    TableEntries,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, toastAlert],
  data() {
    return {
      toDateWithMonth,
      toDateWithYear,
      toYearWithDate,
      checkDateFormat,
      formatAmount,
      toBalance,
      required,
      maxValue,
      positive,
      isDisabled: false,
      isIgnoreProductDefault: false,
      isLoading: false,
      isEditable: false,
      isAllowMoratorium: false,
      isRepaymentType: false,
      isInterestRepaymentType: false,
      isReadonly: false,
      showSpinner: false,
      showComputedInterest: false,
      showSearchButton: false,
      showBackButton: false,
      showCustomerInfo: false,
      showFormErrorAlert: false,
      isRemitaSearchLoading: false,
      isRemitaSearchDisabled: false,
      isProceedingWithRemita: false,
      sortBy: 'accountName',
      productDefaultRules: '',
      rules: '',
      moratoriumDurationRules: '',
      searchType: '',
      customerList: [],
      guarantors: [],
      interestApplicableOptions: [],
      customerTypeOptions: ['Individual', 'Group'],
      loanFeesOptions: [],
      loanAccountDetails: {
        productName: '',
        applicableInterest: '',
      },
      useProductInterestRate: false,
      loanAccountFormData: {
        accountOfficerCode: '',
        accountOfficerName: '',
        customerID: '',
        linkedNumber: '',
        productCode: '',
        loanProductName: '',
        lendingModel: '',
        economicSector: '',
        principalToBeRepaidEvery: 0,
        penaltyGracePeriod: 0,
        loanAmount: null,
        interestCommencementDate: null,
        hasCollateralPledge: false,
        collateralType: '',
        collateralValuation: 0,
        collateralDescription: null,
        principalRepaymentType: '',
        principalFrequency: '',
        applicableInterestCode: '',
        applicableInterestRate: 0,
        defaultingInterestRate: 0,
        interestRepaymentType: '',
        interestFrequency: '',
        interestToBeRepaidEvery: 0,
        interestAccrualMode: '',
        interestInstallment: 0,
        principalInstallment: 0,
        interestFreePrincipalAmount: 0,
        securityDeposit: 0,
        applyLoanFees: false,
        accountCreationChannel: '',
        startDate: '',
        firstRepaymentDate: null,
        tenure: 0,
        loanFees: [],
        allowMoratorium: '',
        moratoriumDuration: 0,
        moratoriumFrequency: '',
        moratoriumEffect: '',
        enableRepaymentTracker: false,
        repaymentTrackerInDays: '',
        referenceNumber: '',
        employeeID: '',
        isAllowDisbursementsToGL: false,
        allowDisbursementsToGL: false,
        clearingBankGL: '',
        collectionProviderCustomerID: '',
        collectionAuthorisationCode: '',
        collectionAccountNumber: '',
        collectionBankCode: '',
        currencyCode: '',
      },
      isLoadingComputeInterest: false,
      isDisabledComputeInterest: false,
      isLoadingRepaymentSchedule: false,
      isDisabledRepaymentSchedule: false,
      actionType: 'add',
      repaymentTypeOptions: repaymentTypes,
      frequencyOptions: repaidFrequencies,
      lendingModelOptions: lendingModel,
      economicSectorOptions: industrialSectorsAndCod,
      interestAccrualOptions: interestAccruals,
      periodPenaltyOptions: periodPenalties,
      penaltyChargeOptions: penaltyCharges,
      securityDepositOptions: securityDeposits,
      securityTypesOptions: securityTypes,
      securityDepositTypeOptions: securityDepositTypes,
      limitOptions: limits,
      principalDueAndUnpaidOptions: [],
      signatoryMandateList: [],
      interestReceivableOptions: [],
      customerAccountOptions: [],
      interestIncomeOptions: [],
      loanFeeOptions: [],
      loanProductItems: [],
      feeDetails: [],
      computedInterest: null,
      descriptionCount: 0,
      guarantorList: [],
      loanProductList: [],
      interestApplicationOptions: [],
      accountOfficerOptions: [],
      repaymentSchedules: [],
      newRepaymentSchedules: [],
      clearingBankOptions: [],
      customerType: '',
      securityDepositType: '',
      securityDepositCharge: '',
      searchParams: {
        customerID: '',
        name: '',
        email: '',
      },
      repaymentSchedulePagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      guarantorPagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      customerSearchPagination: {
        currentPage: 1,
        from: this.customerSearchFrom,
        to: this.customerSearchTo,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      guarantorSearchFormData: {
        customerID: '',
        name: '',
        email: '',
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'customerName', sortable: true, label: 'Customer Name' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'phoneNumber', sortable: true, label: 'Phone Number' },
      ],

      repaymentScheduleTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'paymentDate', sortable: true, label: 'Repayment Date' },
        { key: 'principal', sortable: true, label: 'Principal' },
        { key: 'interest', sortable: true, label: 'Profit' },
        { key: 'fee', sortable: true, label: 'Loan Fee' },
        { key: 'totalRepayment', sortable: true, label: 'Total Repayment' },
        { key: 'paymentStatus', sortable: true, label: 'Payment Status' },
      ],

      signatoryMandateTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'fullName', sortable: true, label: 'Full Name' },
        { key: 'passport', sortable: true, label: 'Passport' },
        { key: 'signature', sortable: true, label: 'Signature' },
      ],

      guarantorTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'customerName', sortable: true, label: 'Customer Name' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'phoneNumber', sortable: true, label: 'Phone Number' },
      ],
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        defaultDate: '',
        ariaDateFormat: 'd/m/Y',
      },
      permission: '',
      getStatusColor,
      avatarLg: '',
      avatarModalTitle: '',
      moratoriumEffectOptions: moratoriumEffect,
      moratoriumFrequencyOptions: repaidFrequencies,
      moratoriumTypeOptions: moratoriumType,
      annualPrincipalFrequency: '',
      customer: {
        customerName: '',
        branchName: '',
        accountName: '',
        productName: '',
        accountOfficerName: '',
        accountStatus: '',
        hasOutstandingLoan: false,
        outstandingLoan: null,
      },
      documentsFormData: [{
        type: '',
        url: '',
        file: '',
      }],
      viewDocumentData: '',
      viewDocumentModalTitle: '',
      fileExtension: '',
      documentLoadSpinner: false,
      documentTypeOptions: [
        { value: 1, label: 'Signature Specimen' },
        { value: 2, label: 'Proof Of Address' },
        { value: 3, label: 'Driver’s License' },
        { value: 4, label: 'National Identity Card' },
        { value: 5, label: 'Voters Card' },
        { value: 6, label: 'National Identity Number' },
        { value: 7, label: 'International Passport' },
        { value: 8, label: 'Passport Photograph' },
        { value: 9, label: 'Reference Letter' },
        { value: 10, label: 'Guarantor’s Letter' },
        { value: 11, label: 'Loan Application Form' },
        { value: 12, label: 'Credit Bureau Form' },
        { value: 13, label: 'Others' },
      ],
      documentIdentifier: '',
      pdfIcon,
      wordIcon,
      remitaLookUpData: {
        firstName: '',
        lastName: '',
        middleName: '',
        accountNumber: '',
        bvn: '',
        bankCode: '',
        authorisationCode: '',
      },
      salaryPaymentTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'amount', sortable: true, label: 'Amount' },
        { key: 'paymentDate', sortable: true, label: 'Payment Date' },
        { key: 'bankCode', sortable: true, label: 'Bank Code' },
      ],

      loanHistoryTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'loanProvider', sortable: true, label: 'Loan Provider' },
        { key: 'loanAmount', sortable: true, label: 'Loan Amount' },
        { key: 'outstandingAmount', sortable: true, label: 'Outstanding Amount' },
        { key: 'repaymentAmount', sortable: true, label: 'Repayment Amount' },
        { key: 'repaymentFreq', sortable: true, label: 'Repayment Frequency' },
        { key: 'loanDisbursementDate', sortable: true, label: 'Loan Disbursement Date' },
        { key: 'status', sortable: true, label: 'Status' },
      ],
      salaryPaymentDetails: [],
      loanHistoryDetails: [],
      loanHistoryDetailsPagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      salaryPaymentDetailsPagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      salaryBankOptions: [],
      collectionProviderCustomerID: '',
      collectionAuthorisationCode: '',
      equalMonthlyInstallment: false,
      getInterestInstallment: '',
      previousLoanAccountData: {
        principalToBeRepaidEvery: 0,
        principalFrequency: '',
        interestAccrualMode: '',
        interestRepaymentType: '',
        interestToBeRepaidEvery: 0,
        interestFrequency: '',
        interestInstallment: 0,
      },
    }
  },
  computed: {
    descriptionCountClass() {
      return this.descriptionCount > 150 ? 'text-danger' : ''
    },
    searchButtonClass() {
      if (this.actionType === 'add') {
        return ''
      }
      return 'd-none'
    },
    guarantorLimit() {
      if (this.guarantorList.length > 1) {
        return true
      }
      return false
    },
    loanHistoryDetailsFrom() {
      return (this.loanHistoryDetailsPagination.currentPage * this.loanHistoryDetailsPagination.perPage) - (this.loanHistoryDetailsPagination.perPage - 1)
    },
    loanHistoryDetailsTo() {
      return Math.min(this.loanHistoryDetailsFrom + this.loanHistoryDetailsPagination.perPage - 1, this.loanHistoryDetailsPagination.totalEntries)
    },
    salaryPaymentDetailsFrom() {
      return (this.salaryPaymentDetailsPagination.currentPage * this.salaryPaymentDetailsPagination.perPage) - (this.salaryPaymentDetailsPagination.perPage - 1)
    },
    salaryPaymentDetailsTo() {
      return Math.min(this.salaryPaymentDetailsFrom + this.salaryPaymentDetailsPagination.perPage - 1, this.salaryPaymentDetailsPagination.totalEntries)
    },
    repaymentFrom() {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - (this.repaymentSchedulePagination.perPage - 1)
    },
    repaymentTo() {
      return Math.min(this.repaymentFrom + this.repaymentSchedulePagination.perPage - 1, this.repaymentSchedulePagination.totalEntries)
    },
    guarantorFrom() {
      return (this.guarantorPagination.currentPage * this.guarantorPagination.perPage) - (this.guarantorPagination.perPage - 1)
    },
    guarantorTo() {
      return Math.min(this.guarantorFrom + this.guarantorPagination.perPage - 1, this.guarantorPagination.totalEntries)
    },
    customerSearchFrom() {
      return (this.customerSearchPagination.currentPage * this.customerSearchPagination.perPage) - (this.customerSearchPagination.perPage - 1)
    },
    customerSearchTo() {
      return Math.min(this.customerSearchFrom + this.customerSearchPagination.perPage - 1, this.customerSearchPagination.totalEntries)
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedRepaymentScheduleTableHeaders() {
      return this.repaymentScheduleTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSignatoryMandateTableHeaders() {
      return this.signatoryMandateTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedGuarantorTableHeaders() {
      return this.guarantorTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSalaryPaymentTableHeaders() {
      return this.salaryPaymentTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedLoanHistoryTableHeaders() {
      return this.loanHistoryTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedDocumentTypeOptions() {
      return this.documentTypeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    csvData() {
      return this.newRepaymentSchedules.map(item => ({
        'Repayment Date': item.paymentDate,
        Principal: toBalance(item.principal),
        Profit: toBalance(item.interest),
        'Loan Fee': toBalance(item.fee),
        'Total Repayment': toBalance(item.totalRepayment),
        'Payment Status': item.paymentStatus,
      }))
    },
    ...mapGetters({
      corporateInformation: 'operations/getCorporateDetails',
    }),
  },
  watch: {
    isIgnoreProductDefault(newValue) {
      if (newValue === true) {
        this.productDefaultRules = 'required'
        this.moratoriumDurationRules = 'required|integer|positive'
      } else {
        this.productDefaultRules = ''
        this.moratoriumDurationRules = ''
        this.loanAccountFormData.allowMoratorium = ''
        this.loanAccountFormData.moratoriumEffect = ''
        this.loanAccountFormData.moratoriumDuration = 0
        this.loanAccountFormData.moratoriumFrequency = ''
      }
    },
    repaymentScheduleCurrentPage(newValue) {
      this.repaymentSchedulePagination.currentPage = newValue
    },
    repaymentSchedulePerPage(newValue) {
      this.repaymentSchedulePagination.perPage = newValue
    },
  },
  mounted() {
    const { type } = this.$route.params
    this.actionType = type
    this.getPermission()
    this.setRules()
    this.getInterestReceivable()
    this.fetchLoanFee()
    this.fetchLoanProducts()
    this.fetchAccountOfficers()
    if (this.actionType === 'add') {
      this.fetchInterestApplicable()
      this.fetchInterestInformation()
    }
    this.getLoanAccountDetails()
    this.getAccounts()
    this.fetchSalaryBanks()
  },
  methods: {
    ...mapActions({
      getProduct: 'account/getProducts',
      customerAccount: 'account/getCustomerAccountList',
      getCustomer: 'account/getCustomerList',
      getCASABalance: 'account/getCASABalanceAction',
      getGLAccountsByAccountType: 'account/getGLAccountsByAccountTypeList',
      getInterestApplicable: 'account/getInterestList',
      createLoanAccount: 'account/createLoanAccountAction',
      updateLoanAccount: 'account/updateLoanAccountAction',
      getLoanFees: 'account/getLoanFeeList',
      getLoanAccount: 'account/getLoanAccount',
      getComputedInterest: 'account/getComputedInterest',
      getPaymentSchedule: 'account/getPaymentSchedule',
      getCustomerImagesByCustomerID: 'account/getCustomerImagesByCustomerID',
      getInterestInformation: 'operations/getInterestInformationList',
      getAccountOfficers: 'account/getAccountOfficerList',
      uploadDocumentImages: 'account/uploadDocumentImagesAction',
      deleteDocumentsUpload: 'account/deleteDocumentsUploadAction',
      getChequeClearingAccountList: 'operations/getChequeClearingAccountList',
      getDocumentFiles: 'account/getDocumentFilesAction',
      getSalaryHistory: 'account/getSalaryHistory',
      getSalaryBankList: 'account/getSalaryBankList',
    }),
    setAccountOfficerName(selectedValue) {
      const selectedAccountOfficer = this.accountOfficerOptions.find(item => item.value === selectedValue)
      this.loanAccountFormData.accountOfficerName = selectedAccountOfficer ? selectedAccountOfficer.label : ''
    },
    checkPrincipalRepayment(value) {
      if (value === 'EqualMonthlyInstallment') {
        this.equalMonthlyInstallment = true
        this.previousLoanAccountData = {
          principalToBeRepaidEvery: this.loanAccountFormData.principalToBeRepaidEvery,
          principalFrequency: this.loanAccountFormData.principalFrequency,
          interestAccrualMode: this.loanAccountFormData.interestAccrualMode,
          interestRepaymentType: this.loanAccountFormData.interestRepaymentType,
          interestToBeRepaidEvery: this.loanAccountFormData.interestToBeRepaidEvery,
          interestFrequency: this.loanAccountFormData.interestFrequency,
          interestInstallment: this.loanAccountFormData.interestInstallment,
        }
        this.loanAccountFormData = {
          ...this.loanAccountFormData,
          principalToBeRepaidEvery: 1,
          principalFrequency: 'Monthly',
          interestAccrualMode: 'ReducingBalanceButEqual',
          interestRepaymentType: 'EqualMonthlyInstallment',
          interestToBeRepaidEvery: 1,
          interestFrequency: 'Monthly',
          interestInstallment: this.loanAccountFormData.principalInstallment,
        }
      } else {
        this.equalMonthlyInstallment = false
        this.loanAccountFormData = {
          ...this.loanAccountFormData,
          principalToBeRepaidEvery: this.previousLoanAccountData.principalToBeRepaidEvery,
          principalFrequency: this.previousLoanAccountData.principalFrequency,
          interestAccrualMode: this.previousLoanAccountData.interestAccrualMode,
          interestRepaymentType: this.previousLoanAccountData.interestRepaymentType,
          interestToBeRepaidEvery: this.previousLoanAccountData.interestToBeRepaidEvery,
          interestFrequency: this.previousLoanAccountData.interestFrequency,
          interestInstallment: this.previousLoanAccountData.interestInstallment,
        }
      }
    },
    addNewDocument() {
      this.documentsFormData.push({
        type: '',
        url: '',
        file: '',
      })
    },
    viewDocumentFile(image, title, fileExtension) {
      this.fileExtension = fileExtension
      this.viewDocumentData = image
      this.viewDocumentModalTitle = title.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ')
      this.$root.$emit('bv::show::modal', 'view-avatar-modal')
    },
    resetDocumentModal() {
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    handleDownload(data) {
      const link = document.createElement('a')
      link.href = data
      link.click()
      this.alertSuccess({ text: this.$t('Your request to download file was successful') })
    },
    async removeDocument(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({ formData, permission: accountPermissions.VIEW_LOAN_ACCOUNT_NIB })
        const { status } = response
        if (status === 200) {
          this.documentLoadSpinner = false
          this.documentsFormData.splice(index, 1)
          this.alertSuccess({ text: this.$t('Document Removed') })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `${this.$t('Delete failed, Reason')}: ${responseError.errorMessage}` })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    async deleteDocumentFile(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({ formData, permission: accountPermissions.VIEW_LOAN_ACCOUNT_NIB })
        const { status } = response
        if (status === 200) {
          this.documentsFormData[index].url = ''
          this.documentLoadSpinner = false
          this.alertSuccess({ text: this.$t('Document Deleted') })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `${this.$t('Delete failed, Reason')}: ${responseError.errorMessage}` })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },

    async onDocumentsUpload(index, event) {
      try {
        this.documentLoadSpinner = true
        const { files } = event.target

        const formData = new FormData()
        formData.append('attachedFile', files[0])
        formData.append('type', this.documentsFormData[index].type)
        formData.append('referenceNumber', this.documentIdentifier)
        const response = await this.uploadDocumentImages({ formData, permission: accountPermissions.VIEW_LOAN_ACCOUNT_NIB })
        const { status, data } = await response
        if (status === 200 && data) {
          this.documentsFormData[index].url = data.url
          this.documentsFormData[index].id = data.id
          this.documentsFormData[index].fileExtension = data.fileExtension
          this.documentLoadSpinner = false
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `${this.$t('Your request to upload image failed. Reason')}: ${responseError.errorMessage}` })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    onViewInfo() {
      this.$root.$emit('bv::show::modal', 'info-modal')
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
      this.resetGuarantorSearchParams()
      this.resetFormData()
    },
    getPageNumber(index) {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - this.repaymentSchedulePagination.perPage + index + 1
    },
    getLoanHistoryPageNumber(index) {
      return (this.loanHistoryDetailsPagination.currentPage * this.loanHistoryDetailsPagination.perPage) - this.loanHistoryDetailsPagination.perPage + index + 1
    },
    salaryPaymentPageNumber(index) {
      return (this.salaryPaymentDetailsPagination.currentPage * this.salaryPaymentDetailsPagination.perPage) - this.salaryPaymentDetailsPagination.perPage + index + 1
    },
    async getAccounts() {
      try {
        const response = await this.getChequeClearingAccountList({
          search: {},
          page: 1,
          limit: 200,
          permission: this.permission,
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.clearingBankOptions = data.data.map(item => ({
            label: `${item.accountName} - ${item.accountNumber}`,
            value: item.accountNumber.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchSalaryBanks() {
      try {
        const response = await this.getSalaryBankList({
          permission: this.permission,
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.salaryBankOptions = data.data.map(item => ({
            label: `${item.name} - ${item.code}`,
            value: item.code.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchAccountOfficers() {
      try {
        const response = await this.getAccountOfficers({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { data, status } = await response
        if (status === 200 && data.data) {
          // eslint-disable-next-line no-nested-ternary
          this.accountOfficerOptions = data.data.filter(item => item.status === 'Active').map(item => ({ label: item.name, value: item.staffID })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchInterestInformation() {
      try {
        const response = await this.getInterestInformation({
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.annualPrincipalFrequency = data.data.numberOfAccruingInterestDaysInAYear
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    setMoratorium(selectedValue) {
      if (selectedValue === 'False') {
        this.isAllowMoratorium = false
        this.moratoriumEffect = null
        this.moratoriumDuration = null
        this.moratoriumFrequency = null
      } else {
        this.isAllowMoratorium = true
      }
    },
    repaymentScheduleNumbering(index) {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - this.repaymentSchedulePagination.perPage + index + 1
    },
    onViewPassport(image, name) {
      this.avatarLg = image
      this.avatarModalTitle = `${name}'s ${this.$t('Passport')}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    onViewSignature(image, name) {
      this.avatarLg = image
      this.avatarModalTitle = `${name}'s ${this.$t('Signature')}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    getPermission() {
      if (this.actionType === 'add') {
        this.permission = accountPermissions.CREATE_LOAN_ACCOUNT_NIB
        return true
      }
      if (this.actionType === 'edit') {
        this.permission = accountPermissions.MODIFY_LOAN_ACCOUNT_NIB
        return true
      }
      this.permission = accountPermissions.VIEW_LOAN_ACCOUNT_NIB
      return true
    },
    computeTenure({ principalFrequency, principalInstallment, principalToBeRepaidEvery }) {
      let frequency
      if (principalFrequency === 'Daily') {
        frequency = 1
      }
      if (principalFrequency === 'Weekly') {
        frequency = 7
      }
      if (principalFrequency === 'Monthly') {
        frequency = 30
      }
      if (principalFrequency === 'Annually') {
        frequency = this.annualPrincipalFrequency
      }

      this.loanAccountFormData.tenure = principalToBeRepaidEvery * frequency * principalInstallment
    },
    computeTenure1(value) {
      this.loanAccountFormData.principalToBeRepaidEvery = value
      if (this.loanAccountFormData.principalToBeRepaidEvery && this.loanAccountFormData.principalFrequency && this.loanAccountFormData.principalInstallment) {
        let frequency
        if (this.loanAccountFormData.principalFrequency === 'Daily') {
          frequency = 1
        }
        if (this.loanAccountFormData.principalFrequency === 'Weekly') {
          frequency = 7
        }
        if (this.loanAccountFormData.principalFrequency === 'Monthly') {
          frequency = 30
        }
        if (this.loanAccountFormData.principalFrequency === 'Annually') {
          frequency = this.annualPrincipalFrequency
        }
        this.loanAccountFormData.tenure = this.loanAccountFormData.principalToBeRepaidEvery * frequency * this.loanAccountFormData.principalInstallment
      }
    },
    computeTenure2(value) {
      this.loanAccountFormData.principalFrequency = value
      if (this.loanAccountFormData.principalToBeRepaidEvery && this.loanAccountFormData.principalFrequency && this.loanAccountFormData.principalInstallment) {
        let frequency
        if (this.loanAccountFormData.principalFrequency === 'Daily') {
          frequency = 1
        }
        if (this.loanAccountFormData.principalFrequency === 'Weekly') {
          frequency = 7
        }
        if (this.loanAccountFormData.principalFrequency === 'Monthly') {
          frequency = 30
        }
        if (this.loanAccountFormData.principalFrequency === 'Annually') {
          frequency = this.annualPrincipalFrequency
        }

        this.loanAccountFormData.tenure = this.loanAccountFormData.principalToBeRepaidEvery * frequency * this.loanAccountFormData.principalInstallment
      }
    },
    computeTenure3(value) {
      this.loanAccountFormData.principalInstallment = value
      if (this.equalMonthlyInstallment) {
        this.loanAccountFormData.interestInstallment = value
      }
      if (this.loanAccountFormData.principalToBeRepaidEvery && this.loanAccountFormData.principalFrequency && this.loanAccountFormData.principalInstallment) {
        let frequency
        if (this.loanAccountFormData.principalFrequency === 'Daily') {
          frequency = 1
        }
        if (this.loanAccountFormData.principalFrequency === 'Weekly') {
          frequency = 7
        }
        if (this.loanAccountFormData.principalFrequency === 'Monthly') {
          frequency = 30
        }
        if (this.loanAccountFormData.principalFrequency === 'Annually') {
          frequency = this.annualPrincipalFrequency
        }
        this.loanAccountFormData.tenure = this.loanAccountFormData.principalToBeRepaidEvery * frequency * this.loanAccountFormData.principalInstallment
      }
    },
    handleSearch() {
      try {
        this.$refs.searchRules.validate().then(async success => {
          if (success) {
            const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
            if (!isSearchParamsNotEmpty) {
              this.showFormErrorAlert = false
              this.showSpinner = true
              const hasFetchedCustomer = await this.fetchCustomer()

              this.showSpinner = false
              if (hasFetchedCustomer) {
                this.$root.$emit('bv::show::modal', 'search-modal')
              }
            } else {
              this.showFormErrorAlert = true
            }
          }
        })
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    setEndDate(dateStr) {
      const selectedDate = Array.isArray(dateStr) ? dateStr[0] : dateStr
      this.loanAccountFormData.interestCommencementDate = getEndDate(selectedDate, 1)
    },
    async setApplicableInterest(selectedValue) {
      try {
        const response = await this.getInterestApplicable({
          search: { code: selectedValue },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = await response
        if (status === 200) {
          this.loanAccountFormData.applicableInterestRate = data.data[0].rate
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    csvExport() {
      const arrData = this.newRepaymentSchedules.map(item => ({
        'Repayment Date': item.paymentDate,
        Principal: formatAmount(item.principal),
        Profit: formatAmount(item.interest),
        'Loan Fee': formatAmount(item.fee),
        'Total Repayment': formatAmount(item.totalRepayment),
        'Payment Status': item.paymentStatus,
      }))
      exportToCSV({ arrData, title: this.corporateInformation.registeredName.toUpperCase(), fileName: 'Repayment Schedule' })
    },
    excelExport(arrData) {
      exportToExcel({
        arrData, title: this.corporateInformation.registeredName.toUpperCase(), fileName: 'Repayment Schedule',
      })
    },

    pdfExport() {
      const columns = [
        { title: this.$t('Repayment Date'), key: 'paymentDate' },
        { title: this.$t('Principal'), key: 'principal' },
        { title: this.$t('Profit'), key: 'interest' },
        { title: this.$t('Loan Fee'), key: 'fee' },
        { title: this.$t('Total Repayment'), key: 'totalRepayment' },
        { title: this.$t('Payment Status'), key: 'paymentStatus' },
      ]
      exportToPDF({
        arrData: this.repaymentSchedules,
        columns,
        institutionName: this.corporateInformation.registeredName,
        fileName: `${this.$t('Repayment Schedule')}.pdf`,
      })
    },
    async setLoanFee(selectedValue) {
      try {
        const selectedLoanProduct = this.loanProductList.find(item => item.value === selectedValue)
        this.loanAccountFormData.loanProductName = selectedLoanProduct ? selectedLoanProduct.label : ''

        const response = await this.getProduct({
          search: { code: selectedValue },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200) {
          const [loanProduct] = data.data

          if (!loanProduct.applyDefaultingLoanInterest) {
            this.loanAccountFormData.defaultingInterestRate = 0
          } else {
            this.loanAccountFormData.defaultingInterestRate = loanProduct.defaultingInterestPercentage
          }
          this.loanAccountFormData.tenure = loanProduct.tenure
          this.loanAccountFormData.penaltyGracePeriod = loanProduct.penaltyGracePeriod
          this.loanAccountFormData.moratoriumDuration = loanProduct.moratoriumDuration
          this.loanAccountFormData.moratoriumEffect = loanProduct.moratoriumEffect
          this.loanAccountFormData.moratoriumFrequency = loanProduct.moratoriumFrequency
          this.loanAccountFormData.allowMoratorium = loanProduct.allowMoratorium
          this.setMoratorium(loanProduct.allowMoratorium)
          this.loanAccountFormData.enableRepaymentTracker = loanProduct.enableRepaymentTracker
          this.loanAccountFormData.repaymentTrackerInDays = loanProduct.repaymentTrackerInDays
          this.loanAccountFormData.principalRepaymentType = loanProduct.principalRepaymentType
          this.loanAccountFormData.principalToBeRepaidEvery = loanProduct.principalToBeRepaidEvery
          this.loanAccountFormData.principalFrequency = loanProduct.principalFrequency
          this.loanAccountFormData.principalInstallment = loanProduct.principalInstallment
          this.loanAccountFormData.interestRepaymentType = loanProduct.interestRepaymentType
          this.loanAccountFormData.interestToBeRepaidEvery = loanProduct.interestToBeRepaidEvery
          this.loanAccountFormData.interestFrequency = loanProduct.interestFrequency
          this.loanAccountFormData.interestInstallment = loanProduct.interestInstallment
          this.loanAccountFormData.applyLoanFees = loanProduct.applyLoanFees
          this.loanAccountFormData.interestAccrualMode = loanProduct.interestAccrualMode
          this.loanAccountFormData.isAllowDisbursementsToGL = loanProduct.allowDisbursementsToGL
          this.loanAccountFormData.currencyCode = loanProduct.currencyCode
          this.loanAccountFormData.applicableInterestCode = loanProduct.interestCode
          this.computeTenure({
            principalFrequency: loanProduct.principalFrequency,
            principalInstallment: loanProduct.principalInstallment,
            principalToBeRepaidEvery: loanProduct.principalToBeRepaidEvery,
          })

          let productLoanFees

          if (loanProduct.productLoanFees && loanProduct.productLoanFees.length) {
            const feeCodes = loanProduct.productLoanFees.map(item => item.loanFeeCode)
            productLoanFees = this.feeDetails.filter(items => {
              if (feeCodes.includes(items.code)) {
                return items
              }
              return false
            }).map(item => ({ label: item.name, value: item.code }))
          }
          this.loanAccountFormData.loanFees = loanProduct.applyLoanFees ? productLoanFees : []
          this.securityDepositType = loanProduct.securityDepositType
          this.securityDepositCharge = loanProduct.securityDepositCharge

          if (this.loanAccountFormData.loanAmount) {
            this.setSecurityDeposit(loanProduct.securityDepositType)
          }
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async onSelectCustomer(items) {
      this.hideModal('search-modal')
      this.showSpinner = true
      const customerInfo = { ...items[0] }
      this.customer.customerName = customerInfo.customerName
      this.loanAccountFormData.customerID = customerInfo.customerID
      this.signatoryMandateList = [{
        fullName: customerInfo.name,
        passport: customerInfo.passportFileUrl,
        signature: customerInfo.signatureFileUrl,
      }]
      await this.getLinkedCustomerAccounts()
      this.showCustomerInfo = true
      this.showSearchButton = true
      this.showBackButton = true

      this.showSpinner = false
    },
    setSecurityDeposit() {
      if (this.actionType === 'add') {
        if (this.securityDepositType === 'FlatAmount') {
          this.loanAccountFormData.securityDeposit = this.securityDepositCharge
        } else {
          this.loanAccountFormData.securityDeposit = (this.securityDepositCharge / 100) * this.loanAccountFormData.loanAmount
        }
      }
    },
    async setCustomerDetails(selectedValue) {
      try {
        this.showSpinner = true
        const response = await this.customerAccount({
          search: { accountNumber: selectedValue },
          page: 0,
          limit: 0,
          permission: this.permission,
        })

        const { data, status } = response
        if (status === 200) {
          const [customer] = data.data
          this.customer = { ...customer }
          this.loanAccountFormData = {
            ...this.loanAccountFormData,
            accountOfficerCode: customer.accountOfficerCode,
            accountOfficerName: customer.accountOfficerName,
          }
          // if (this.actionType === 'add') {
          const balanceInfo = await this.getCASABalance({
            accountNumber: customer.accountNumber,
            permission: this.permission,
          })

          this.customer.hasOutstandingLoan = balanceInfo.data.hasLoanOutstandingAmount === true ? 'Yes' : 'No'
          this.customer.outstandingLoan = toBalance(balanceInfo.data.totalOutstandingLoan)
          // }
        }
        this.showSpinner = false
      } catch (error) {
        this.alertError({ text: error })
        this.showSpinner = false
      } finally {
        this.showSpinner = false
      }
    },
    async fetchCustomer() {
      try {
        const response = await this.getCustomer({
          search: this.searchParams,
          page: this.currentPage,
          limit: this.perPage,
          permission: this.permission,
        })

        const { data, status } = response
        if (status === 200 && data.data !== null) {
          this.customerList = data.data.map(item => ({
            ...item,
            customerName: item.name,
          }))
          this.getDocumentByDocumentIdentifier(this.customerList[0].documentIdentifier)
          this.remitaLookUpData = {
            firstName: this.customerList[0].firstName,
            lastName: this.customerList[0].lastName,
            middleName: this.customerList[0].otherNames,
          }
          this.customerSearchPagination.totalEntries = data.recordCount
          return true
        }
        this.alertError({ text: this.$t('No record found') })
        return false
      } catch (error) {
        this.alertError({ text: error })
      }
      return false
    },
    async getDocumentByDocumentIdentifier(documentIdentifier) {
      this.documentIdentifier = documentIdentifier
      try {
        const response = await this.getDocumentFiles({
          referenceNumber: documentIdentifier,
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.documentsFormData = data.data ? data.data.map(item => ({
            url: item.url,
            type: item.typeID,
            fileName: item.type,
            id: item.id,
            fileExtension: item.fileExtension,
          })) : [{
            url: '',
            type: '',
          }]
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async getLinkedCustomerAccounts() {
      try {
        const response = await this.customerAccount({
          search: { customerID: this.loanAccountFormData.customerID },
          page: 0,
          limit: 0,
          permission: this.permission,
        })

        const { data, status } = await response
        if (status === 200 && data.data) {
          this.customerAccountOptions = data.data.filter(dataItem => dataItem.accountStatus === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.customerName}/${curr.accountNumber}/${curr.productName}`, value: curr.accountNumber }], [])
        } else {
          this.alertError({ text: this.$t('No linked accounts found') })
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    // setRepaymentFrequency(value) {
    //   if (value === 'Prorated') {
    //     this.isRepaymentType = true
    //     this.loanAccountFormData.principalFrequency = null
    //     return false
    //   }
    //   this.isRepaymentType = false
    //   return true
    // },
    // setInterestRepaymentFrequency(value) {
    //   if (value === 'Prorated') {
    //     this.isInterestRepaymentType = true
    //     this.loanAccountFormData.interestFrequency = null
    //     return false
    //   }
    //   this.isInterestRepaymentType = false
    //   return true
    // },
    async handleGuarantorSearch() {
      try {
        this.showSpinner = true
        const response = await this.getCustomer({
          search: this.guarantorSearchFormData,
          page: this.currentPage,
          limit: this.perPage,
          permission: this.permission,
        })

        const { data, status } = response
        if (status === 200 && data.data !== null) {
          this.guarantors = data.data.map(item => ({
            ...item,
            customerName: item.name,
            phoneNumber: item.customerType === 'Individual' ? item.phoneNumber : item.businessPhoneNumber,
          }))
          this.guarantorPagination.totalEntries = data.recordCount
          this.showSpinner = false
          this.hideModal('guarantor-modal')
          this.$root.$emit('bv::show::modal', 'guarantor-search-modal')
        } else {
          this.alertError({ text: this.$t('No record found') })
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    onSelectGuarantor(items) {
      this.hideModal('guarantor-search-modal')
      const customerInfo = { ...items[0] }
      if (this.guarantorList.length <= 1) {
        const existingGuarantor = this.guarantorList.find(item => item.customerName === customerInfo.customerName)
        if (existingGuarantor === undefined) {
          this.guarantorList.push(customerInfo)
        } else {
          this.alertError({ text: this.$t('User has already been added as guarantor') })
        }
      } else {
        this.alertError({ text: this.$t('Maximum number of Guarantors is 2') })
      }
    },
    async fetchInterestApplicable() {
      try {
        const response = await this.getInterestApplicable({
          search: { type: 'Debit' },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200) {
          this.interestApplicationOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({
            label: item.name,
            value: item.code,
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async fetchLoanProducts() {
      try {
        this.isBusy = true
        const response = await this.getProduct({
          search: { type: 'Loan' },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200) {
          this.loanProductItems = data.data
          this.loanProductList = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({
            label: item.name,
            value: item.code.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
      return true
    },
    async computeInterest() {
      try {
        if (this.loanAccountFormData.applyLoanFees && !this.loanAccountFormData.loanFees.length) {
          this.alertError({ text: this.$t('Please select applicable loan fees') })
        } else {
          this.showSpinner = true
          const loanFees = this.loanAccountFormData.loanFees.length
            ? this.loanAccountFormData.loanFees.map(item => {
              if (typeof item !== 'object') {
                return { loanFeeCode: item }
              }
              return { loanFeeCode: item.value, name: item.label }
            }) : []
          const response = await this.getComputedInterest({
            permission: accountPermissions.VIEW_LOAN_ACCOUNT_NIB,
            formData: {
              accountNumber: this.loanAccountFormData.accountNumber,
              name: this.loanAccountFormData.customerName,
              customerID: this.loanAccountFormData.customerID,
              productCode: this.loanAccountFormData.productCode,
              linkedNumber: this.loanAccountFormData.linkedNumber,
              principalToBeRepaidEvery: this.loanAccountFormData.principalToBeRepaidEvery || 0,
              principalInstallment: this.loanAccountFormData.principalInstallment || 0,
              interestToBeRepaidEvery: this.loanAccountFormData.interestToBeRepaidEvery || 0,
              interestInstallment: this.loanAccountFormData.interestInstallment || 0,
              penaltyGracePeriod: this.loanAccountFormData.penaltyGracePeriod || 0,
              loanAmount: toKobo(this.loanAccountFormData.loanAmount),
              approvedDate: this.loanAccountFormData.approvedDate,
              interestCommencementDate: this.loanAccountFormData.interestCommencementDate ? toYearWithDate(this.loanAccountFormData.interestCommencementDate) : null,
              startDate: toYearWithDate(this.loanAccountFormData.startDate),
              firstRepaymentDate: this.loanAccountFormData.firstRepaymentDate ? toYearWithDate(this.loanAccountFormData.firstRepaymentDate) : null,
              endDate: this.loanAccountFormData.endDate,
              principalRepaymentType: this.loanAccountFormData.principalRepaymentType,
              principalFrequency: this.loanAccountFormData.principalFrequency,
              applicableInterestCode: this.loanAccountFormData.applicableInterestCode,
              applicableInterestRate: this.loanAccountFormData.applicableInterestRate,
              defaultingInterestRate: this.loanAccountFormData.defaultingInterestRate,
              interestRepaymentType: this.loanAccountFormData.interestRepaymentType,
              interestFrequency: this.loanAccountFormData.interestFrequency,
              interestAccrualMode: this.loanAccountFormData.interestAccrualMode,
              interestFreePrincipalAmount: toKobo(this.loanAccountFormData.interestFreePrincipalAmount),
              applyLoanFees: this.loanAccountFormData.applyLoanFees,
              loanFeesRequest: loanFees,
              loanFees: [],
              allowMoratorium: this.loanAccountFormData.allowMoratorium,
              moratoriumEffect: this.loanAccountFormData.moratoriumEffect,
              moratoriumDuration: this.loanAccountFormData.moratoriumDuration || 0,
              moratoriumFrequency: this.loanAccountFormData.moratoriumFrequency,
            },
          })
          const totalInterestAmount = `${this.$t('Total Profit Amount')} = ${toBalance(response.data.totalInterestAmount)}`
          const totalDays = `${this.$t('Total Days')} = ${response.data.totalDays}`
          this.computedInterest = `${totalInterestAmount} \n ${totalDays}`

          this.showSpinner = false
          this.showComputedInterest = true
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    onViewSignatoryMandate() {
      this.$root.$emit('bv::show::modal', 'signatory-mandate-table')
    },
    async onViewRepaymentSchedule() {
      try {
        if (this.loanAccountFormData.applyLoanFees && !this.loanAccountFormData.loanFees.length) {
          this.alertError({ text: this.$t('Please select applicable loan fees') })
        } else {
          this.showSpinner = true
          const loanFees = this.loanAccountFormData.loanFees.length
            ? this.loanAccountFormData.loanFees.map(item => {
              if (typeof item !== 'object') {
                return { loanFeeCode: item }
              }
              return { loanFeeCode: item.value, name: item.label }
            }) : []
          const response = await this.getPaymentSchedule({
            permission: accountPermissions.VIEW_LOAN_ACCOUNT_NIB,
            formData: {
              accountNumber: this.loanAccountFormData.accountNumber,
              name: this.loanAccountFormData.customerName,
              customerID: this.loanAccountFormData.customerID,
              productCode: this.loanAccountFormData.productCode,
              linkedNumber: this.loanAccountFormData.linkedNumber,
              principalToBeRepaidEvery: this.loanAccountFormData.principalToBeRepaidEvery,
              principalInstallment: this.loanAccountFormData.principalInstallment,
              interestToBeRepaidEvery: this.loanAccountFormData.interestToBeRepaidEvery,
              interestInstallment: this.loanAccountFormData.interestInstallment,
              penaltyGracePeriod: this.loanAccountFormData.penaltyGracePeriod,
              loanAmount: toKobo(this.loanAccountFormData.loanAmount),
              approvedDate: this.loanAccountFormData.approvedDate,
              interestCommencementDate: this.loanAccountFormData.interestCommencementDate ? toYearWithDate(this.loanAccountFormData.interestCommencementDate) : null,
              startDate: toYearWithDate(this.loanAccountFormData.startDate),
              firstRepaymentDate: this.loanAccountFormData.firstRepaymentDate ? toYearWithDate(this.loanAccountFormData.firstRepaymentDate) : null,
              endDate: this.loanAccountFormData.endDate,
              principalRepaymentType: this.loanAccountFormData.principalRepaymentType,
              principalFrequency: this.loanAccountFormData.principalFrequency,
              applicableInterestCode: this.loanAccountFormData.applicableInterestCode,
              applicableInterestRate: this.loanAccountFormData.applicableInterestRate,
              defaultingInterestRate: this.loanAccountFormData.defaultingInterestRate,
              interestRepaymentType: this.loanAccountFormData.interestRepaymentType,
              interestFrequency: this.loanAccountFormData.interestFrequency,
              interestAccrualMode: this.loanAccountFormData.interestAccrualMode,
              interestFreePrincipalAmount: toKobo(this.loanAccountFormData.interestFreePrincipalAmount),
              applyLoanFees: this.loanAccountFormData.applyLoanFees,
              loanFeesRequest: loanFees,
              loanFees: [],
              allowMoratorium: this.loanAccountFormData.allowMoratorium,
              moratoriumEffect: this.loanAccountFormData.moratoriumEffect,
              moratoriumDuration: this.loanAccountFormData.moratoriumDuration || 0,
              moratoriumFrequency: this.loanAccountFormData.moratoriumFrequency,
            },
          })
          const { status, data } = response
          if (status === 200) {
            this.repaymentSchedules = data.data.map(item => ({
              ...item,
              fee: toBalance(item.fee),
              interest: toBalance(item.interest),
              paymentDate: toDateWithMonth(item.paymentDate),
              paymentStatus: addSpaceToString(item.paymentStatus),
              principal: toBalance(item.principal),
              totalRepayment: toBalance(item.totalRepayment),
            }))
            this.newRepaymentSchedules = data.data.map(item => ({
              ...item,
              fee: item.fee,
              interest: item.interest,
              paymentDate: toDateWithMonth(item.paymentDate),
              paymentStatus: addSpaceToString(item.paymentStatus),
              principal: item.principal,
              totalRepayment: item.totalRepayment,
            }))
            this.repaymentSchedulePagination.totalEntries = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'repayment-schedule-modal')
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    onViewRemitaLookup() {
      this.$root.$emit('bv::show::modal', 'remita-lookup-search-table')
    },
    async handleRemitaSearch() {
      this.$refs.remitaLookupRef.validate().then(async success => {
        if (success) {
          try {
            this.isRemitaSearchLoading = true
            this.isRemitaSearchDisabled = true
            const response = await this.getSalaryHistory({
              formData: this.remitaLookUpData,
              permission: this.permission,
            })
            const { status, data } = response
            if (status === 200 && data.data) {
              this.salaryPaymentDetails = data.data.salaryPaymentDetails
              this.loanHistoryDetails = data.data.loanHistoryDetails
              this.salaryPaymentDetailsPagination.totalEntries = data.data.salaryPaymentDetails.length
              this.loanHistoryDetailsPagination.totalEntries = data.data.loanHistoryDetails.length
              this.collectionProviderCustomerID = data.data.customerId
              this.collectionAuthorisationCode = data.data.authorisationCode
              this.isProceedingWithRemita = true
            }
          } catch (error) {
            this.handleError(error)
          } finally {
            this.isRemitaSearchLoading = false
            this.isRemitaSearchDisabled = false
          }
        }
      })
    },
    proceedWithRemita() {
      this.loanAccountFormData.collectionProviderCustomerID = this.collectionProviderCustomerID
      this.loanAccountFormData.collectionAuthorisationCode = this.collectionAuthorisationCode
      this.loanAccountFormData.collectionAccountNumber = this.remitaLookUpData.accountNumber
      this.loanAccountFormData.collectionBankCode = this.remitaLookUpData.bankCode
      this.alertSuccess({ text: this.$t('Remita Integration Acknowledged') })
      this.hideModal('remita-lookup-search-table')
    },
    removeGuarantorItem(index) {
      this.guarantorList.splice(index, 1)
    },
    setDescriptionCount(noOfText) {
      if (noOfText) {
        this.descriptionCount = noOfText.length
      }
    },
    setCollateral(value) {
      if (!value) {
        this.loanAccountFormData.collateralType = null
        this.loanAccountFormData.collateralValuation = null
        this.loanAccountFormData.collateralDescription = null
        return false
      }
      return true
    },
    setRepaymentTracker(value) {
      if (!value) {
        this.loanAccountFormData.repaymentTrackerInDays = null
        return false
      }
      return true
    },
    setApplyLoanFee(value) {
      if (!value) {
        this.loanAccountFormData.loanFees = []
        return false
      }
      return true
    },
    async getInterestReceivable() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 13, permission: this.permission })
        const { status, data } = await response

        if (status === 200) {
          this.interestReceivableOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async fetchLoanFee() {
      try {
        const response = await this.getLoanFees({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = await response

        if (status === 200) {
          this.feeDetails = data.data
          this.loanFeeOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.computationModel === 'Flat' ? toBalance(curr.amount) : curr.amount}`, value: curr.code }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async handleSubmit() {
      this.confirm(this.loanAccountAction, { title: '', text: `${this.$t('Are you sure you want to')} ${this.actionType === 'add' ? 'Save' : 'Modify'} this Loan?` })
    },
    async loanAccountAction() {
      try {
        this.isLoading = true
        this.isDisabled = true

        const loanFees = this.loanAccountFormData.loanFees !== null
          ? this.loanAccountFormData.loanFees.map(item => {
            if (typeof item !== 'object') {
              return { loanFeeCode: item }
            }
            return { loanFeeCode: item.value, name: item.label }
          }) : []
        const formData = {
          customerName: this.customer.customerName,
          accountName: this.customer.accountName,
          name: this.customer.customerName,
          branchName: this.customer.branchName,
          ...this.loanAccountFormData,
          documentIdentifier: this.documentIdentifier,
          loanFees,
          guarantorID1: this.guarantorList[0] !== undefined ? this.guarantorList[0].customerID : null,
          guarantorID2: this.guarantorList[1] !== undefined ? this.guarantorList[1].customerID : null,
          startDate: toYearWithDate(this.loanAccountFormData.startDate),
          firstRepaymentDate: this.loanAccountFormData.firstRepaymentDate ? toYearWithDate(this.loanAccountFormData.firstRepaymentDate) : null,
          interestCommencementDate: this.loanAccountFormData.interestCommencementDate ? toYearWithDate(this.loanAccountFormData.interestCommencementDate) : null,
          loanAmount: toKobo(this.loanAccountFormData.loanAmount),
          collateralValuation: toKobo(this.loanAccountFormData.collateralValuation),
          securityDeposit: toKobo(this.loanAccountFormData.securityDeposit),
          interestFreePrincipalAmount: toKobo(this.loanAccountFormData.interestFreePrincipalAmount),
          moratoriumDuration: this.loanAccountFormData.moratoriumDuration || 0,
          penaltyGracePeriod: this.loanAccountFormData.penaltyGracePeriod || 0,
          defaultingInterestRate: this.loanAccountFormData.defaultingInterestRate || 0,
        }
        const response = this.actionType === 'add'
          ? await this.createLoanAccount(formData)
          : await this.updateLoanAccount(formData)

        const { status } = await response
        if (status === 200) {
          if (this.actionType === 'add') {
            this.alertSuccess({ text: this.$t('Your loan application is complete. Please proceed to the list page for final disbursement of funds to the recipient') })
          } else {
            this.alertSuccess({ text: this.$t('Your request to Update Loan account was successful') })
          }

          this.$router.push({ name: 'loan-list' })
        }
      } catch (error) {
        this.isLoading = false
        this.isDisabled = false
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    setRules() {
      if (this.actionType === 'add' || this.actionType === 'edit') {
        this.rules = 'required'
      }
      this.rules = ''
    },
    async getLoanAccountDetails() {
      try {
        const { id, type } = this.$route.params
        if (id !== undefined) {
          this.showSpinner = true
          this.showCustomerInfo = true
          this.showSearchButton = true
          this.showBackButton = true
          this.actionType = type
          this.isDisabled = type !== 'edit'
          this.isEditable = true
          this.isReadonly = type !== 'edit'
          // this.$refs.loanAccount.activateAll()

          const response = await this.getLoanAccount({ id, permission: this.permission })
          const { data, status } = response
          if (status === 200) {
            this.customer.customerName = data.data.name
            this.loanAccountFormData.customerID = data.data.customerID
            await this.getLinkedCustomerAccounts()

            await this.setCustomerDetails(data.data.linkedNumber)
            // this.customer.hasOutstandingLoan = data.data.hasLoanOutstandingAmount === true ? 'Yes' : 'No'
            // this.customer.outstandingLoan = toAmount(balanceInfo.totalOutstandingLoan)
            const responsee = await this.getCustomerImagesByCustomerID({ customerID: data.data.customerID, permission: this.permission })

            this.signatoryMandateList = [{
              fullName: data.data.name,
              passport: responsee.data.data.passportFileUrl,
              signature: responsee.data.data.signatureFileUrl,
            }]
            // debugger
            let guarantor1
            let guarantor2

            if (data.data.guarantor1 !== null) {
              guarantor1 = { customerName: data.data.guarantor1.name, phoneNumber: data.data.guarantor1.phoneNumber }
            }

            if (data.data.guarantor2 !== null) {
              guarantor2 = { customerName: data.data.guarantor2.name, phoneNumber: data.data.guarantor2.phoneNumber }
            }

            if (guarantor1 && guarantor2) {
              this.guarantorList = [guarantor1, guarantor2]
            } else if (guarantor1) {
              this.guarantorList = [guarantor1]
            } else if (guarantor2) {
              this.guarantorList = [guarantor2]
            } else {
              this.guarantorList = []
            }
            // this.guarantorList = (guarantor1 && guarantor2) ? [guarantor1, guarantor2] : []

            let loanFees
            // this.setRepaymentFrequency(data.data.principalRepaymentType)
            // this.setInterestRepaymentFrequency(data.data.interestRepaymentType)

            if (data.data.loanFees) {
              const feeCodes = data.data.loanFees.map(item => item.loanFeeCode)
              loanFees = this.feeDetails.filter(items => {
                if (feeCodes.includes(items.code)) {
                  return items
                }
                return false
              }).map(item => ({ label: item.name, value: item.code }))
            }

            this.setDescriptionCount(data.data.collateralDescription)
            this.loanAccountFormData = {
              id: data.data.id,
              accountOfficerCode: data.data.accountOfficerCode,
              linkedNumber: data.data.linkedNumber,
              productCode: data.data.productCode,
              lendingModel: data.data.lendingModel,
              economicSector: data.data.economicSector,
              penaltyGracePeriod: data.data.penaltyGracePeriod || '0',
              loanAmount: toBalance(data.data.loanAmount),
              interestCommencementDate: data.data.interestCommencementDate ? toDateWithYear(data.data.interestCommencementDate) : '',
              hasCollateralPledge: data.data.hasCollateralPledge,
              collateralType: data.data.collateralType,
              collateralValuation: toBalance(data.data.collateralValuation),
              collateralDescription: data.data.collateralDescription,
              principalRepaymentType: data.data.principalRepaymentType,
              principalFrequency: data.data.principalFrequency,
              applicableInterestCode: data.data.applicableInterestCode,
              applicableInterestRate: data.data.applicableInterestRate,
              defaultingInterestRate: data.data.defaultingInterestRate || 0,
              interestRepaymentType: data.data.interestRepaymentType,
              interestFrequency: data.data.interestFrequency,
              interestAccrualMode: data.data.interestAccrualMode,
              interestFreePrincipalAmount: toBalance(data.data.interestFreePrincipalAmount),
              securityDeposit: toBalance(data.data.securityDeposit) || '0',
              applyLoanFees: data.data.applyLoanFees,
              accountCreationChannel: data.data.accountCreationChannel,
              startDate: toDateWithYear(data.data.startDate),
              firstRepaymentDate: data.data.firstRepaymentDate ? toDateWithYear(data.data.firstRepaymentDate) : null,
              principalToBeRepaidEvery: data.data.principalToBeRepaidEvery,
              principalInstallment: data.data.principalInstallment || '0',
              interestToBeRepaidEvery: data.data.interestToBeRepaidEvery,
              interestInstallment: data.data.interestInstallment || '0',
              loanFees,
              tenure: data.data.tenure,
              enableRepaymentTracker: data.data.enableRepaymentTracker,
              repaymentTrackerInDays: data.data.repaymentTrackerInDays,
              referenceNumber: data.data.referenceNumber,
              employeeID: data.data.employeeID,
              allowDisbursementsToGL: data.data.allowDisbursementsToGL,
              clearingBankGL: data.data.clearingBankGL,
              currencyCode: data.data.currencyCode,
            }

            this.documentIdentifier = data.data.documentIdentifier ? data.data.documentIdentifier : this.documentIdentifier
            this.documentsFormData = data.data.documents ? data.data.documents.map(item => ({
              url: item.url,
              type: item.typeID,
              fileName: item.type,
              id: item.id,
              fileExtension: item.fileExtension,
            })) : [{
              url: '',
              type: '',
            }]
            this.loanAccountDetails = {
              productName: data.data.productName,
              applicableInterest: data.data.interestName,
            }
            this.datePickerConfig.defaultDate = toDateWithYear(data.data.interestCommencementDate)
            this.showSpinner = false
            this.$refs.loanAccount.activateAll()
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    onChangeTab() {
      const dropDownSelect = document.querySelector('#loan-fee').querySelectorAll('.vs__selected')
      dropDownSelect.forEach(item => {
        item.classList.add('selected')
      })
    },
    resetAvatarModal() {
      this.avatarLg = ''
      this.avatarModalTitle = ''
    },
    resetSearchParams() {
      this.searchParams = { ...null }
    },
    resetGuarantorModal() {
      this.guarantorSearchFormData = { ...null }
    },
    resetGuarantorSearchParams() {
      this.guarantorSearchFormData = { ...null }
    },
    resetFormData() {
      this.loanAccountFormData = { ...null }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'loan-list-nib',
      })
    },
    validateLoanService() {
      return new Promise((resolve, reject) => {
        this.$refs.loanService.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateLoanAccountInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.loanAccountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateRepaymentInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.repaymentInfo.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateCollateralAndSecurity() {
      return new Promise((resolve, reject) => {
        this.$refs.collateralSecurity.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validatUploads() {
      return new Promise((resolve, reject) => {
        this.$refs.uploadRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-image{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 250px;
    height: 250px
}
.format {
    color: #999999 !important;
}
form input[type=file]{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction{
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
